import { useState } from 'react';
import Select, { components } from 'react-select';
import { selectStyle } from './styles';

interface IReactSelectMultiProps {
  setSelectedOptions: any;
  allOptions: any;
  placeholder: string;
  values: any[];
}

const ClearIndicator = (props: any) => {
  return (
    <components.ClearIndicator {...props}>
      <strong>Limpar</strong>
    </components.ClearIndicator>
  );
};

const InputOption = ({
  getStyles,
  Icon,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  placeholder,
  ...rest
}: any) => {
  const [isActive, setIsActive] = useState(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const onMouseLeave = () => setIsActive(false);

  // styles
  let bg = 'transparent';
  if (isFocused) bg = '#eee';
  if (isActive) bg = '#B2D4FF';

  const style = {
    alignItems: 'center',
    backgroundColor: bg,
    color: 'inherit',
    display: 'flex ',
  };

  // prop assignment
  const props = {
    ...innerProps,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    style,
  };

  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >
      <input type="checkbox" checked={isSelected} />
      {children}
    </components.Option>
  );
};

export default function ReactSelectMulti({
  setSelectedOptions,
  allOptions,
  placeholder,
  values,
}: IReactSelectMultiProps) {
  return (
    <div className="App">
      <Select
        defaultValue={[]}
        value={values}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option: InputOption,
          ClearIndicator,
        }}
        options={allOptions}
        onChange={(options: any) => {
          if (Array.isArray(options)) {
            setSelectedOptions(options);
          }
        }}
        styles={selectStyle}
        placeholder={placeholder}
      />
      {/* <pre>{JSON.stringify({ selected: selectedOptions }, null, 2)}</pre> */}
    </div>
  );
}
